import { render, staticRenderFns } from "./MyBlackOrder.vue?vue&type=template&id=100c0d01&scoped=true"
import script from "./MyBlackOrder.vue?vue&type=script&lang=js"
export * from "./MyBlackOrder.vue?vue&type=script&lang=js"
import style0 from "./MyBlackOrder.vue?vue&type=style&index=0&id=100c0d01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100c0d01",
  null
  
)

export default component.exports